import { TYPES } from "../actions";

const initialState = {
  pcInfos: [],
  totalCount: 0,
  currentPCInfo: null,
  loading: false
};

export const tkt1PCInfoReducer = (state = initialState, action) => {
  switch (action.type) {

    case TYPES.ACTION_GET_TKT1_PC_INFOS_SUCCESS:
      return { 
        ...state, 
        pcInfos: action.payload.data.result, 
        totalCount: action.payload.data.totalCount > -1 ? action.payload.data.totalCount : state.totalCount,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_PC_INFOS_FAIL:
      return { 
        ...state, 
        pcInfos: [],
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_PC_INFO_BY_ID_SUCCESS:
      return { 
        ...state, 
        currentPCInfo: action.payload.data,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_PC_INFO_BY_ID_FAIL:
      return { 
        ...state, 
        currentPCInfo: null,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_PC_INFO_BY_SN_SUCCESS:
      return { 
        ...state, 
        currentPCInfo: action.payload.data,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_PC_INFO_BY_SN_FAIL:
      return { 
        ...state, 
        currentPCInfo: null,
        loading: false
      };

    case TYPES.ACTION_CREATE_TKT1_PC_INFO_SUCCESS:
      return { 
        ...state, 
        pcInfos: [action.payload.data, ...state.pcInfos],
        totalCount: state.totalCount + 1,
        loading: false
      };

    case TYPES.ACTION_CREATE_TKT1_PC_INFO_FAIL:
      return { 
        ...state, 
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_PC_INFO_SUCCESS:
      return { 
        ...state, 
        pcInfos: state.pcInfos.map(info => 
          info._id === action.payload.data._id ? action.payload.data : info
        ),
        currentPCInfo: state.currentPCInfo && state.currentPCInfo._id === action.payload.data._id 
          ? action.payload.data 
          : state.currentPCInfo,
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_PC_INFO_FAIL:
      return { 
        ...state, 
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_PC_INFO_BY_SN_SUCCESS:
      return { 
        ...state, 
        pcInfos: state.pcInfos.map(info => 
          info.SN === action.payload.data.SN ? action.payload.data : info
        ),
        currentPCInfo: state.currentPCInfo && state.currentPCInfo.SN === action.payload.data.SN 
          ? action.payload.data 
          : state.currentPCInfo,
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_PC_INFO_BY_SN_FAIL:
      return { 
        ...state, 
        loading: false
      };

    case TYPES.ACTION_DELETE_TKT1_PC_INFO_SUCCESS:
      return { 
        ...state, 
        pcInfos: state.pcInfos.filter(info => info._id !== action.payload.id),
        totalCount: Math.max(0, state.totalCount - 1),
        currentPCInfo: state.currentPCInfo && state.currentPCInfo._id === action.payload.id 
          ? null 
          : state.currentPCInfo,
        loading: false
      };

    case TYPES.ACTION_DELETE_TKT1_PC_INFO_FAIL:
      return { 
        ...state, 
        loading: false
      };
      
    default:
      return state;
  }
};
